import React, { useEffect, useState } from 'react'
import {
  Flex,
  H1WithBack,
  TabsContainer,
  Tabs,
  PageWrapper,
  ContentWrapper,
} from '../../styling/GlobalStyles'
import { AddEmployeerWrapper } from './AddEmployee.styled'
import { EmployeeBasicInfoTab } from './EmployeeBasicInfoTab'
import { EmployeesContractsTab } from './EmployeesContractsTab'
import { NavBar } from '../../components/NavBar/NavBar'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { clearEmployee, getSingleUser, updateUser } from 'features/users(Employees)/usersSlice'
import { AppDispatch, RootState } from 'store'
import { toast } from 'react-toastify'
import { IContract, IEmployee } from 'types/users.interface'
import { employeesInitialState } from './employeesData'
import { EmployeeBankInfoTab } from './EmployeeBankInfoTab'
import { EmployeeWelfareTab } from './EmployeeWelfateTab'
import { EmployeesNotesTab } from './EmployeesNotesTab'

export const EditEmployee = () => {
  const [active, setActive] = useState('Basic Info')
  const dispatch = useDispatch<AppDispatch>()
  const { singleUser } = useSelector((store: RootState) => store.users)
  const [invalidFields, setInvalidFields] = useState([])
  const [invalidBankFields, setInvalidBankFields] = useState([])
  const [invalidWelfareFields, setInvalidWelfareFields] = useState([])
  const navigate = useNavigate()
  const { id } = useParams()
  const [state, setState] = useState<IEmployee>(employeesInitialState)

  console.log(invalidFields)

  useEffect(() => {
    dispatch(getSingleUser(id))
    return () => {
      dispatch(clearEmployee())
    }
  }, [id])

  useEffect(() => {
    if (singleUser) {
      setState(structuredClone(singleUser))
    }
  }, [singleUser])


  const handleSubmit = async () => {
    const copy = structuredClone(state)
    if (invalidFields.length > 0) {
      toast.warn('All basic info fields must be valid')
      return
    }

    if (state.notes.some(note => !note.content || !note.visibilityScope || !note.category)) {
      toast.warn('Please fill all note fields with valid values')
      return
    }

    const resp = await dispatch(updateUser(copy))
    if (resp.meta.requestStatus === 'fulfilled') {
      navigate('/hr/employees')
    }
  }
  const renderTabs = () => {
    if (active === 'Basic Info') {
      return (
        <EmployeeBasicInfoTab
          setState={setState}
          state={state}
          handleSubmit={handleSubmit}
          invalidFields={invalidFields}
          setInvalidFields={setInvalidFields}
        />
      )
    } else if (active === 'Bank Info') {
      return <EmployeeBankInfoTab setInvalidFields={setInvalidBankFields} invalidFields={invalidBankFields} setState={setState} state={state} handleSubmit={handleSubmit} />
    } else if (active === 'Welfare') {
      return <EmployeeWelfareTab setState={setState} state={state} invalidFields={invalidWelfareFields} setInvalidFields={setInvalidWelfareFields} handleSubmit={handleSubmit} />
    } else if (active === 'Contract') {
      return <EmployeesContractsTab setState={setState} state={state} handleSubmit={handleSubmit} />
    }
    return <EmployeesNotesTab setState={setState} state={state} handleSubmit={handleSubmit} />
  }

  const changeTab = (name: string) => {
    if (active == 'Contract' && state.contracts.some((c: IContract) => !c.value)) {
      toast.warn('Contracts must be saved first')
    } else if (active == 'Welfare' && invalidWelfareFields.length) {
      toast.warn('Please fill all required fields with valid values before proceeding')
    } else if (active == ' Bank Info' && invalidBankFields.length) {
      toast.warn('Please fill all required fields with valid values before proceeding')
    } else {
      setActive(name)
    }
  }


  return (
    <AddEmployeerWrapper>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between main>
          <H1WithBack arrow title='Edit Employee' />
          <TabsContainer mediaQShifts >
            <Tabs active={active === 'Basic Info'} onClick={() => changeTab('Basic Info')}>
              Basic Info
            </Tabs>
            <Tabs active={active === 'Bank Info'} onClick={() => changeTab('Bank Info')}>
              Bank Info
            </Tabs>
            <Tabs active={active === 'Contract'} onClick={() => changeTab('Contract')}>
              Contract
            </Tabs>
            <Tabs active={active === 'Documents'} onClick={() => changeTab('Documents')}>
              Documents
            </Tabs>
          </TabsContainer>


        </Flex>

        <ContentWrapper noFooter>{renderTabs()}</ContentWrapper>
      </PageWrapper>
    </AddEmployeerWrapper>
  )
}
